// extracted by mini-css-extract-plugin
module.exports = {"page__secondImage":"materica-module--page__secondImage--20AFO"};